export enum ROLE {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
  ROOT = 'ROLE_ROOT',
  JOB_MANAGER = 'ROLE_JOB_MANAGER'
}
